import Component from '../abstracts/Component';
import vex from "vex-js";
import {IS_CHINA} from "../utils/Environment";
// quick refactoring of privacyComponent
export default class NewPrivacyComponent extends Component {

  static get SELECTORS() {
    return {
      Form: ".js-validate-form",
    };
  }

  onB2Csignin() {
    $('body').on('change.bpr', 'input[name="param10"]', function (e) {
      $('.js-password-box').toggleClass('hidden');
    });
  }

  onNewsletterSignUp() {
    $('#newsletterForm').find('input[id="privacy"]').on('change.nlp', function (e) {
      const target = e.currentTarget;
      let id = target.id;
      let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
      let isDisabled = basicNewsletterSubmit.getAttribute('disabled');

      if (isDisabled) {
        $(basicNewsletterSubmit).attr("disabled", false);
      } else {
        $(basicNewsletterSubmit).attr("disabled", true);
      }
    });
  }

  onNewsletterLandingSignUp() {
    $('#newsletterLandingForm').find('input[id="privacy"]').on('change.nlp', function (e) {
      const target = e.currentTarget;
      let id = target.id;
      let basicNewsletterSubmit = document.querySelector('button[data-target="' + id + '"]');
      let isDisabled = basicNewsletterSubmit.getAttribute('disabled');

      if (isDisabled) {
        $(basicNewsletterSubmit).attr("disabled", false);
        }else{
        $(basicNewsletterSubmit).attr("disabled", true);
      }
    });
  }

  basicPrivacyAcceptance() {
    let ctx = this;

    let isKr = (document.body.dataset.website === 'kr');

    if (!isKr) {
      if(! $('input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]').prop('checked')){
        $('#registerForm').find('button[type="submit"]').attr("disabled", true);
      }

      $('body').on('change.bpr', 'input[id="basicPrivacy"], input[id="basicPrivacy-ft"], input[id="privacyNl_2"]', function (e) {
        e.stopImmediatePropagation();

        let $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        let $form = $(e.currentTarget).closest('form');

        console.log($container);
        if ($(e.currentTarget).is(':checked')) {
          $container.removeClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", false);

          let allFlagsChecked = ctx.allFlagsChecked();

          if (allFlagsChecked) {
            $form.find('button[type="submit"],button[type="button"]').attr("disabled", false);
            $form = $('#basicPrivacy').closest('.container-privacy').find('#buttons a');
            $form.attr("disabled", false);
            $form.removeClass('disabled');
        }
          if ($('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }
          if ($form.hasClass('js-contact-form')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }
          if ($("#newsletterForm input[name=privacy]").is(':checked')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }
        } else {
          $container.addClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", true);
          $form.find('button[type="submit"]').attr("disabled", true);
          if (!IS_CHINA)
          {
            $container.find('#newsletterProfiling1').prop("checked", false);
            $container.find('#newsletter1').prop("checked", false);
          }
          $form = $('#basicPrivacy').closest('.container-privacy').find('#buttons a');
          $form.attr("disabled", true);
      	  $form.addClass('disabled');
        }
      });

      $('body').on('change.radioPrivacy', '[name="newsletterProfiling"], [name="newsletter"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        let $form = $(e.currentTarget).closest('form');

        let allFlagsChecked = ctx.allFlagsChecked();

        if (allFlagsChecked) {
            $form.find('button[type="submit"]').attr("disabled", false);
            //login privacy gdpr
            $form = $('#basicPrivacy').closest('.container-privacy').find('#buttons a');
            $form.attr("disabled", false);
            $form.removeClass('disabled');
        }
      });

      $('body').on('change.radioPrivacyRecall', '[name="recalledBrandPrivacyData.profiled"], [name="recalledBrandPrivacyData.newsletter"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('form');

        if ( $('[name="recalledBrandPrivacyData.profiled"]').is(':checked') && $('[name="recalledBrandPrivacyData.newsletter"]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
      });


      $('body').on('click', '.updatePrivacyButton', function (e) {
        const $container = $(e.currentTarget).closest('form');
        const currentNewsletterProfiling = $container.find(".current-profiling input:checked").attr('value');
        const currentNewsletter = $container.find(".current-newsletter input:checked").attr('value');
        const thirdParties = $container.find("#thirdParties1").is(':checked');
        const crossBorder = $container.find("#crossBorder1").is(':checked');
        const newsletterProfiling =$container.find("#postageyesProfiling").is(':checked');
        const newsletter = $container.find("#postageyes").is(':checked');
        const privacy = $container.find("#basicPrivacy").is(':checked');

        $(this).attr('disabled', 'disabled');

        var $this = $(this);
        var href = $(".submit").data('href');

        $.ajax({
          url: href,
          type: 'POST',
          data: {
            'new-form-privacy': true,
            currentNewsletterProfiling: currentNewsletterProfiling,
            thirdParties: thirdParties,
            crossBorder: crossBorder,
            currentNewsletter: currentNewsletter,
            newsletterProfiling: newsletterProfiling,
            newsletter: newsletter,
            privacy: privacy
          },
          dataType: "html"
        }).done(function (resp) {

          console.log(resp);
          var respJson = JSON.parse(resp);
          $('.vex-close').trigger('click');
          $('.alert-success').removeClass("hidden");
          $('.success-alert').removeClass("hidden");

          if (typeof respJson.redirectUrl !== 'undefined') {
            setTimeout(function () {
              window.location.href = respJson.redirectUrl;
            }, 3000);
          }

        }).fail(function (xhr) {
          console.log(xhr);
        });

        // For Safari
        document.body.scrollTop = 0;
        // For Chrome, Firefox, IE and Opera
        document.documentElement.scrollTop = 0;
      });

      $('body').on('click', '.wrapper-login-privacy .icon-close', function (e) {
        e.stopPropagation();
        $(this).closest('.alert-success').addClass('hidden');
      });
    }
  }

  allFlagsChecked() {
    let $newsletter = $('[name=newsletter]');
    let isNewsletterChecked = $newsletter.is(':checked');
    let $newsletterProfiling = $('[name=newsletterProfiling]');
    let isNewsletterProfilingChecked = $newsletterProfiling.is(':checked');

    let allFlagsChecked = isNewsletterProfilingChecked && isNewsletterChecked;

    if (IS_CHINA) {
      let $thirdParties = $('[name=thirdPartiesAck]');
      let isThirdPartiesChecked = $thirdParties.is(':checked');
      let $crossBorder = $('[name=crossBorderAck]');
      let isCrossBorderChecked = $crossBorder.is(':checked');

      allFlagsChecked = allFlagsChecked && isThirdPartiesChecked && isCrossBorderChecked;
    }

    return allFlagsChecked;
  }

  privacyChat() {
    $('body').on('change.radioPrivacyChat', 'input[id="privacy_livechat"]', function (e) {
      e.stopImmediatePropagation();
      if ($('#privacy_livechat').is(':checked')) {
        $('#chatForm button[type="submit"]').attr("disabled", false);
      } else {
        $('#chatForm button[type="submit"]').attr("disabled", true);
      }
    });
  }

  // recall privacy function
  // similar to older websites
  recallPrivacyConfirm(){
    let ctx = this;
    $('body').on('click','.js-apply-recall-options',function(e){
      let ctx = this;
      e.preventDefault();
      e.stopImmediatePropagation();
      let content = $('#privacy-usubscribe-modal').html();

      ctx.$emit(this.$customEvents.MODAL_EVENTS.show, {
        unsafeContent: content
      })
    })
  }

  getPage(url, showLoader = true) {
    const ajaxConf = {
      type: 'GET',
      url: url,
    };

    if (showLoader) ajaxConf.beforeSend = () => this.$emit(this.$customEvents.LOADER_EVENTS.show);

    return $.ajax(ajaxConf);
      }

  showPrivacyModal(){
    this.showPrivacyModal = $('body').data('showPrivacyModal');

    if (this.showPrivacyModal) {

      this.getPage('/action/ajax/modalprivacy')
        .then(res => {
        this.$emit(this.$customEvents.MODAL_EVENTS.show, {
          unsafeContent: res,
          modalClass: 'modal-privacy-recall vex-medium-width',
        });
    })
    .then( () => {
        $('.js-single-item').slick({
        draggable: false,
        arrows: false,
      });
      $('a[data-slide]').click(function(e) {
        e.preventDefault();
        let currentSlide = $(this).data('slide');
        $('.js-single-item').slick('slickGoTo', currentSlide - 1);
      });

      $('.js-wrapper-privacy-recall').on('change.privacyRecallModal', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

        if ($(e.currentTarget).is(':checked')) {
          $container.removeClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", false);
          if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
            $form.find('.js-apply-recall-options-modal').attr("disabled", false);
          }
        } else {
          $container.addClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", true);
          $container.find('#newsletterProfiling1').prop("checked", false);
          $container.find('#newsletter1').prop("checked", false);
          $form.find('.js-apply-recall-options-modal').attr("disabled", true);
        }
      });

      $('[name="newsletterProfiling"], [name="newsletter"]').on('change.radioPrivacyRecallModal', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('.js-privacyRecallModal').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('.js-privacyRecallModal');

        if ( $('[name="newsletterProfiling"]').is(':checked') && $('[name="newsletter"]').is(':checked')) {
          $form.find('.js-apply-recall-options-modal').attr("disabled", false);
        }
      });
      this.recallPrivacyStep2();

    });
    }
  }

  recallPrivacyStep2(){
    $('body').on('click.recallPrivacyStep2', '.js-apply-recall-options-modal' ,function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let newsletterProfiling = $('#newsletterProfiling1').prop('checked') ? true:false;
      let newsletter = $('#newsletter1').prop('checked') ? true:false;

      ///update privacy
      let currentNewsletterProfiling = $('[name="currentNewsletterProfiling"]').attr('value');
      let currentNewsletter = $('[name="currentNewsletter"]').attr('value');
      let href = $(this).data('href');

      $.ajax({
        url: href,
        type : 'POST',
        data : {
          'new-form-privacy': true,
          currentNewsletterProfiling: currentNewsletterProfiling,
          currentNewsletter : currentNewsletter,
          newsletterProfiling : newsletterProfiling,
          newsletter : newsletter,
          privacy : true
        },
        dataType : "html"
      }).done(function(resp) {

        let respJson = JSON.parse(resp);

        $('.vex-close').trigger('click');
        if(resp == '{}'){
          $('.js-recall-privacy-message').removeClass("hidden");
        } else {
          $('.js-recall-privacy-message-error').removeClass("hidden");
        }

      }).fail(function(xhr) {
        console.log(xhr);
      });
    })
  }

  privacyChina(){
    $('#thirdParties1').change(function() {
      $('#thirdParties1').attr('checked', true);
      $('[name="newsletterProfiling"], [name="newsletter"]').trigger('change.radioPrivacy');
    });
    $('#thirdParties2').change(function() {
      $('#thirdParties2').attr('checked', true);
      $('[name="newsletterProfiling"], [name="newsletter"]').trigger('change.radioPrivacy');
    });
    $('#crossBorder1').change(function() {
      $('#crossBorder1').attr('checked', true);
      $('[name="newsletterProfiling"], [name="newsletter"]').trigger('change.radioPrivacy');
    });
    $('#crossBorder2').change(function() {
      $('#crossBorder2').attr('checked', true);
      $('[name="newsletterProfiling"], [name="newsletter"]').trigger('change.radioPrivacy');
    });
  }

  onInputChange(){
    const ctx = this;
    $(document).on('change', 'input[type="radio"], input[name="param7"]', function() {
      ctx.validateSubmitButton(ctx);
    });
  }

  // Check if all input elements have values
  validateSubmitButton(ctx) {
    const genericData = $('#genericData').serializeArray()
    try{
      var param7 = genericData.find(gd => gd.name === 'param7');
      var profiled = genericData.find(gd => gd.name === 'profiled');
      var format = $("#param7").data('date-format');
      var minDate = $("#param7").data('mindate');
      var maxDate = $("#param7").data('maxdate');

      if(param7 !== undefined && param7.value.length > 0 && ctx.isValidDate(param7.value, format, minDate, maxDate) && profiled !== undefined && profiled.value.length > 0){
        $('#btn-submit-profiling').prop('disabled', false);
      }else{
        $('#btn-submit-profiling').prop('disabled', true);
      }
    }catch(e){
      console.error(e)
      $('#btn-submit-profiling').prop('disabled', true);
    }
  }

  isValidDate(date, format, minDate, maxDate) {
    if ( minDate == null || maxDate == null) {
      return true;
    }
    const parsedDate = this.parseDate(date, format);
    const min = new Date(minDate);
    const max = new Date(maxDate);

    return parsedDate >= min && parsedDate <= max;
  }

  parseDate(dateStr, format) {
      let day, month, year;

      if (format === 'd-m-Y') {
          [day, month, year] = dateStr.split('-');
      } else if (format === 'm-d-Y') {
          [month, day, year] = dateStr.split('-');
      } else if (format === 'Y-m-d') {
          [year, month, day] = dateStr.split('-');
      }

      return new Date(year, month - 1, day);
  }

  onFormSubmit() {
    $('form').on('submit', function(event) {
      var dateFormat = $('input[name="param7"]').attr('data-date-format');

      var backendValue = $(this).find('input[name="param7"]').val();
      var dateParts = backendValue.split('/');

      if (dateFormat.toLowerCase() == 'm/d/y') {

        var formattedValue = dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2];
        $(this).find('input[name="param7"]').val(formattedValue);
      } else {
        $(this).find('input[name="param7"]').val(backendValue.replaceAll("/","-").replaceAll(".","-"));
      }
    });
  }

  isPrivacyPage(){
    if ($("body").hasClass("t-privacy")) {
      return true;
    }
    return false;
  }

  render() {
    super.render();
    this.onNewsletterSignUp();
    this.onNewsletterLandingSignUp();
    this.basicPrivacyAcceptance();
    this.privacyChat();
    this.onB2Csignin();
    this.showPrivacyModal();
    if(this.isPrivacyPage()){
      this.onInputChange();
      this.onFormSubmit();
    }
    if (IS_CHINA) {
      this.privacyChina();
    }
    // this.recallPrivacyConfirm();
  }
}
